var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravelAndTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EFF5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4984 22.8814H9.50151C8.73843 22.8814 8.12305 22.2881 8.12305 21.5288V13.1526C8.12305 12.417 8.83689 11.7288 9.59997 11.7288H11.5692V10.5424C11.5692 9.80679 12.283 9.11865 13.0461 9.11865H18.9538C19.7169 9.11865 20.4307 9.80679 20.4307 10.5424V11.7288H22.4C23.163 11.7288 23.8769 12.417 23.8769 13.1526V21.5526C23.8769 22.2881 23.2615 22.8814 22.4984 22.8814ZM19.2 10.7797C19.2 10.5898 18.9292 10.3051 18.7077 10.3051H13.2923C13.0707 10.3051 12.8 10.5898 12.8 10.7797V11.7288H19.2V10.7797Z",
    fill: "#3781F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelAndTransportation);
export default __webpack_public_path__ + "static/media/Travel-and-transportation.1285bed7.svg";
export { ForwardRef as ReactComponent };